import type { AriaAttributes, ReactNode } from 'react';

import classNames from 'classnames';

import styles from './GridContainer.module.css';

export type GridContainerBreakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export type GridContainerHTMLElements = 'div' | 'ul';

export interface GridContainerProps extends AriaAttributes {
  as?: GridContainerHTMLElements;
  /* Toggle full width */
  enabled?: boolean;
  /**
   * Breakpoints to skip, as skipped breakpoint will use the next lowest
   * un-skipped breakpoint size
   */
  skip?: GridContainerBreakpoint[];
  children?: ReactNode;
  className?: string;
}

/**
 * Creates a CSS container with `display: grid`. When enabled, restrict its max
 * width to some specific sizes according to the screen breakpoint.
 *
 * @deprecated To constrain the max-width, use the {@link Section} component with
 *   width constraints. To create grid layouts, use {@link Grid}.
 * @see https://corgi-x.tfd.engineering/components/gridcontainer
 */
export function GridContainer(props: GridContainerProps) {
  const {
    children,
    enabled = true,
    skip = [],
    className,
    as: HTMLElement = 'div',
    ...ariaAttributes
  } = props;
  return (
    <HTMLElement
      className={classNames(
        styles.container,
        { [styles.disabled]: !enabled },
        ...skip.map(s => styles[`skip-${s}`]),
        className
      )}
      {...ariaAttributes}
    >
      {children}
    </HTMLElement>
  );
}
